import { User } from '../user';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class LoginSerializer extends BaseSerializer {
  deserialize(raw) {
    console.log('🚀 ~ LoginSerializer ~ deserialize ~ raw:', raw);
    // Nouveau format de réponse: { statusCode: 200, message: "...", data: { user: {...} } }
    const apiResponse = raw;
    const success = !apiResponse?.error && apiResponse?.statusCode === 200;

    let parsedUser = null;
    if (success && apiResponse?.data) {
      const userData = apiResponse.data;
      if (userData.metadata?.isDeleted) {
        return {
          success: false,
          statusCode: apiResponse?.statusCode,
          message:
            "Votre compte a été supprimé. Veuillez contacter le service client pour plus d'informations.",
          errorTitle: 'Compte supprimé',
          user: null,
          token: null
        };
      }
      console.log('🚀 ~ LoginSerializer ~ deserialize ~ userData:', userData);
      parsedUser = {
        id: userData.id || userData._id,
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        phoneNumber: userData.phoneNumber || userData.phone || '',
        countryCode: userData.countryCode,
        createdAt: userData.createdAt,
        updatedAt: userData.updatedAt,
        profilePictureUrl: userData.metadata?.avatar,
        metadata: userData.metadata || { service: 'rapidoo' }
      };
    }

    const errorTexts = success
      ? null
      : errorMessages[`${apiResponse?.statusCode}`] || errorMessages.other;

    return {
      success,
      statusCode: apiResponse?.statusCode,
      message: success
        ? 'ok'
        : apiResponse?.error?.message || errorTexts?.message,
      errorTitle: errorTexts?.title,
      user: success && parsedUser ? new User(parsedUser) : null,
      token: null // La nouvelle API ne renvoie pas de token
    };
  }

  serialize(data) {
    if (!data) return null;
    return {
      email: data.email,
      password: data.password
    };
  }
}

const errorMessages = {
  401: {
    title: 'Identifiants incorrects',
    message: 'Votre mot de passe est incorrect. Veuillez réessayer.'
  },
  404: {
    title: 'Email introuvable',
    message:
      'Aucun compte ne correspond à cet email. Veuillez vérifier et réessayer.'
  },
  400: {
    title: 'Erreur dans les données',
    message:
      'Les informations envoyées sont invalides. Veuillez vérifier et réessayer.'
  },
  other: {
    title: 'Échec de connexion',
    message: 'Une erreur inattendue s’est produite. Veuillez réessayer.'
  }
};

export const loginSerializer = new LoginSerializer();
